'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _underscore = require('underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _ChatHistory = require('conversations-schema/records/ChatHistory');

var _ChatHistory2 = _interopRequireDefault(_ChatHistory);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _UILoading = require('UIComponents/loading/UILoading');

var _UILoading2 = _interopRequireDefault(_UILoading);

var _DateLabel = require('ui-addon-conversations/components/labels/DateLabel');

var _DateLabel2 = _interopRequireDefault(_DateLabel);

var _UrlLabel = require('ui-addon-conversations/components/labels/UrlLabel');

var _UrlLabel2 = _interopRequireDefault(_UrlLabel);

var _MessageGroup = require('ui-addon-conversations/components/MessageGroup');

var _MessageGroup2 = _interopRequireDefault(_MessageGroup);

var _chatHistoryGroups = require('ui-addon-conversations/utils/chatHistoryGroups');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConversationHistory = _react2.default.createClass({
  displayName: 'ConversationHistory',

  propTypes: {
    chatHistory: _react.PropTypes.instanceOf(_ChatHistory2.default).isRequired,
    currentRole: _react.PropTypes.oneOf((0, _underscore.values)(_RoleTypes2.default)).isRequired,
    responders: _react.PropTypes.instanceOf(_immutable.Map),
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default),
    readOnly: _react.PropTypes.bool.isRequired,
    renderMessage: _react.PropTypes.func.isRequired,
    publishMessage: _react.PropTypes.func,
    republishMessage: _react.PropTypes.func,
    children: _react.PropTypes.node
  },

  getDefaultProps: function getDefaultProps() {
    return {
      currentRole: _RoleTypes2.default.REP,
      readOnly: false,
      renderMessage: _underscore.identity
    };
  },
  hasMessageHistory: function hasMessageHistory() {
    var chatHistory = this.props.chatHistory;


    return chatHistory.history.size >= 1;
  },
  isWidget: function isWidget() {
    var currentRole = this.props.currentRole;


    return currentRole === _RoleTypes2.default.VISITOR;
  },
  getOtherRole: function getOtherRole() {
    var currentRole = this.props.currentRole;


    return currentRole === _RoleTypes2.default.REP ? _RoleTypes2.default.VISITOR : _RoleTypes2.default.REP;
  },
  getExternalHistoryList: function getExternalHistoryList() {
    var history = this.props.chatHistory.history;


    var historyList = history.toList();
    return historyList.filter(_ConversationalMessageModel.isConversationalMessage);
  },
  renderMessageHistory: function renderMessageHistory() {
    var _this = this;

    var _props = this.props,
        currentRole = _props.currentRole,
        coloring = _props.coloring,
        readOnly = _props.readOnly,
        publishMessage = _props.publishMessage,
        republishMessage = _props.republishMessage,
        renderMessage = _props.renderMessage,
        responders = _props.responders;


    var externalHistoryList = this.getExternalHistoryList();
    var groupedHistory = (0, _chatHistoryGroups.makeGroupedChatHistory)(externalHistoryList);

    var recentLabels = {};

    return groupedHistory.map(function (group, index) {
      var dateText = (0, _chatHistoryGroups.getDateTextFromGroup)(group);
      var shouldRenderDate = index === 0 || dateText !== recentLabels.date;

      var dateLabelElement = shouldRenderDate ? _react2.default.createElement(_DateLabel2.default, { text: dateText }) : null;

      var url = (0, _chatHistoryGroups.getUrlFromGroup)(group);
      var shouldRenderUrl = !_this.isWidget() && url !== undefined && url !== recentLabels.url;

      var urlLabelElement = shouldRenderUrl ? _react2.default.createElement(_UrlLabel2.default, { url: url }) : null;

      recentLabels = {
        date: shouldRenderDate ? dateText : recentLabels.date,
        url: shouldRenderUrl ? url : recentLabels.url
      };

      var messageGroupElement = _react2.default.createElement(_MessageGroup2.default, {
        messages: group,
        allMessages: externalHistoryList,
        responders: responders,
        currentRole: currentRole,
        coloring: coloring,
        readOnly: readOnly,
        publishMessage: publishMessage,
        republishMessage: republishMessage,
        renderMessage: renderMessage
      });

      return [dateLabelElement, urlLabelElement, messageGroupElement];
    });
  },
  renderLoadingState: function renderLoadingState() {
    var currentRole = this.props.currentRole;


    if (currentRole === _RoleTypes2.default.REP) {
      return _react2.default.createElement(_UILoading2.default, { className: 'loading-indicator', use: 'primary' });
    }

    return null;
  },
  render: function render() {
    if (!this.hasMessageHistory()) {
      return this.renderLoadingState();
    }

    return _react2.default.createElement(
      'div',
      { className: 'flex-column' },
      this.renderMessageHistory(),
      this.props.children
    );
  }
});

exports.default = ConversationHistory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/ConversationHistory.js
// module id = 399
// module chunks = 0 1